export enum EnumLabelTag {
  TAG_MULTIBENEFITS = "tag_multibeneficios",
  TAG_AWARDS = "tag_premiacoes",
  TAG_CORPEXPENSES = "tag_despesas",
  TAG_CAJUMAIS = "tag_cajumais",
  TAG_CAJUCICLOS = "tag_cajuciclos",
}
